/** POST /v1/merchant/local-merchant-coupon/verify-qr body contract. */
export interface VerifyCouponQrRequest {
  token: string;
}

/**
 * Raw verify-qr payload. Field names stay optional because the backend
 * contract is the source of truth; normalization happens at the API boundary.
 */
export interface VerifyCouponQrRawResponse {
  coupon_id?: string | null;
  user_coupon_id?: string | null;
  coupon_title?: string | null;
  title?: string | null;
  merchant_id?: string | null;
  redeemed_at?: string | null;
  used_date?: string | null;
}

/** Feature-friendly redemption result shown on the success state. */
export interface CouponRedeemResult {
  couponTitle: string;
  redeemedAt: string;
}

/** Stable UI error states for verify-qr failures. */
export type RedeemErrorKind = "invalidOrExpired" | "outOfScope" | "alreadyUsed" | "generic";

export const toCouponRedeemResult = (raw: VerifyCouponQrRawResponse): CouponRedeemResult => ({
  couponTitle: raw.coupon_title ?? raw.title ?? "",
  redeemedAt: raw.redeemed_at ?? raw.used_date ?? "",
});
